export default __webpack_public_path__ + "static/media/zertiassist_iconos_map_pin_24px.211b1750.svg";